import React, { Component, PropTypes } from 'react';

class Dialog extends Component {
  componentDidMount() {
    this.toggleModal(
      this.props.name,
      this.props.isOpened
    );
  }

  componentDidUpdate() {
    this.toggleModal(
      this.props.name,
      this.props.isOpened
    );
  }

  toggleModal(name, isOpened) {
    $(`#${name}`)
      .modal({
        onApprove: () => false,
        blurring: true,
      })
      .modal(isOpened ? 'show' : 'hide');
  }

  render() {
    const {
      name,
      header,
      description,
      iconClass,
      confirmButtonText,
      cancelButtonText,
      isTypical,
      onSubmit,
      onCancel,
    } = this.props;

    const typicalClass = isTypical ? '' : 'basic';

    return (
      <div id={name} className={`ui large modal ${typicalClass}`}>
        <div className="ui icon header">
          <i className={`${iconClass} icon`}></i>
          {header}
        </div>
        <div className="content">
          <p className="large text">{description}</p>
        </div>
        <div className="actions">
          <div
            onClick={onCancel}
            className={`ui red inverted button large ${typicalClass}`}
          >
            <i className="remove icon"></i>
            {cancelButtonText}
          </div>
          <div
            onClick={onSubmit}
            className="ui green inverted button large"
          >
            <i className="checkmark icon"></i>
            {confirmButtonText}
          </div>
        </div>
      </div>
    );
  }
}

Dialog.defaultProps = {
  name: 'default-dialog',
  confirmButtonText: 'Yes',
  cancelButtonText: 'No',
  iconClass: 'warning sign',
  header: 'Are you sure?',
  description: 'Action cannot be reversed.',
  isOpened: false,
  isTypical: false,
};

Dialog.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  header: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  description: PropTypes.string,
  name: PropTypes.string,
  confirmButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  iconClass: PropTypes.string,
  isOpened: PropTypes.bool,
  isTypical: PropTypes.bool,
};

export default Dialog;
